import { action, makeAutoObservable } from "mobx";
import * as _ from "lodash";
import { AxiosInstance, AxiosResponse } from "axios";

import env from "../../../config/env";
import http from "../../../services/http";
import {
  ComboBoxData,
  DataTableItemsDto,
  MessageResultState,
  ServiceResult,
} from "../../../types/general-types";
import IPagedResult from "../../../models/dto/fetch/IPagedResult";
import {
  SSOLoginAsUserRequestDto,
  SSOLoginAsUserGridListDto,
  SSOLoginAsUserResponseDto,
  SSOLoginAsExternalUserRequestDto,
  SSOLoginAsExternalUserResponseDto,
} from "./types";
import IPagedRequest from "../../../models/dto/fetch/IPagedRequest";
import qs from "qs";
import { SSOExternalUserGridListDto } from "../ExternalUserManagement/types";
import { getAccounts, getRootAccount } from "../../../utils/SsoSession";

const { API_BASE_URL } = env;
let reportPeriod: string = "";

class LoginAsUserStore {
  static readonly id: string = "LoginAsUserStore";

  users!: IPagedResult<SSOLoginAsUserGridListDto>;
  externalusers!: IPagedResult<SSOExternalUserGridListDto>;
  get api() {
    http.defaults.baseURL = API_BASE_URL;
    return http;
  }
  constructor() {
    makeAutoObservable(this);

    this.users = {
      totalCount: 0,
      items: [],
      isLoaded: false,
    };
    this.externalusers = {
      totalCount: 0,
      items: [],
      isLoaded: false,
    };

    this.all = this.all.bind(this);
    this.allExternal = this.allExternal.bind(this)
  }

  @action.bound async all(params: IPagedRequest | undefined) {
    this.users.isLoaded = false;

    const q = qs.stringify(
      { ...params, sessionKeys: getAccounts().map((a) => a.sessionKey) },
      { encodeValuesOnly: true, addQueryPrefix: true }
    );
    const response: ServiceResult<
      DataTableItemsDto<SSOLoginAsUserGridListDto>
    > = await (
      await this.api.get("/login-as-user/all" + q)
    ).data;
    const users = response.result;
    this.users = { ...users, isLoaded: true };
  }
  @action.bound async allExternal(params: IPagedRequest | undefined) {
    this.externalusers.isLoaded = false;
    const q = qs.stringify(
      { ...params, sessionKeys: getAccounts().map((a) => a.sessionKey) },
      { encodeValuesOnly: true, addQueryPrefix: true }
    );
    const response: ServiceResult<
      DataTableItemsDto<SSOExternalUserGridListDto>
    > = await (
      await this.api.get("/login-as-user/all-external-users" + q)
    ).data;
    const externalusers = response.result;
    this.externalusers = { ...externalusers, isLoaded: true };
  }

  @action.bound async loginAsUser(input: SSOLoginAsUserRequestDto) {
    const result: ServiceResult<SSOLoginAsUserResponseDto> = await (
      await this.api.post(`/login-as-user/entry`, input, {
        headers: { Authorization: getRootAccount()?.sessionKey },
      })
    ).data;
    return result;
  }
  @action.bound async loginAsExternalUser(input: SSOLoginAsExternalUserRequestDto) {
    const result: ServiceResult<SSOLoginAsExternalUserResponseDto> = await (
      await this.api.post(`/login-as-user/entry-external`, input, {
        headers: { Authorization: getRootAccount()?.sessionKey },
      })
    ).data;
    return result;
  }
}

export default LoginAsUserStore;
